var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"settings"}},[_c('contact-details'),(_vm.myProfile.hasPassword)?_c('update-password'):_vm._e(),_c('close-account')],1)}
var staticRenderFns = []

export { render, staticRenderFns }